import React, { useState, useEffect } from 'react'
import { Menu, Row, Col, message } from 'antd'
import { useHistory, useLocation } from 'react-router-dom'
import headerStyle from './header.module.less'
import 'antd/dist/antd.less'

import Cookies from 'js-cookie'

import * as constants from '../../../constants/constants'

import LoginRegisterModal from '../../../component/modal/login-register/login-register'
import UserInfo from '../user-center/user-info'
import { sendHttpPostRequest } from '../../../api/http-request'

export interface Props {
  keys: any
}

const getCurrentMenuKey = (keys: any, pathname: string) => {
  const currentKey = Array.isArray(keys) ? keys[0] : keys

  if (currentKey) {
    return currentKey
  }

  if (pathname === '/' || pathname === '') {
    return ''
  }
  if (pathname === '/projects' || pathname.startsWith('/project')) {
    return 'projects'
  }
  if (pathname === '/key_features') {
    return 'key_features'
  }
  if (pathname === '/colleges') {
    return 'colleges'
  }

  return ''
}

export const PageHeader: React.FC<Props> = (props: Props) => {
  const { keys } = props
  const history = useHistory()
  const location = useLocation()
  const [selectedKey, setSelectedKey] = useState(getCurrentMenuKey(keys, location.pathname))
  const [collegeId, setCollegeId] = useState(null as any) // 院校ID
  const [collegeName, setCollegeName] = useState(null as any) // 院校名称
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher weitrue表示是教师，
  const [logoInfo, setLogoInfo] = useState<any>({})
  const [isTeacher, setIsTeacher] = useState(-1)

  useEffect(() => {
    setSelectedKey(getCurrentMenuKey(keys, location.pathname))
  }, [keys, location.pathname])

  const handleClick = (e: any) => {
    setSelectedKey(e.key)
    if (e.key == 'projects') {
      history.push('/projects')
    } else if (e.key == 'key_features') {
      history.push('/key_features')
    } else if (e.key == 'colleges') {
      history.push('/colleges')
    }
  }

  const handleMainPage = () => {
    history.push('/')
  }

  useEffect(() => {
    const sessionid = Cookies.get('sessionid')
    if (sessionid) {
      sendHttpPostRequest(
        //获取院校身份信息
        'account/api/query_teacher_authenticate',
        {
          sessionid: sessionid,
          sid: sessionid,
        },
        (response: any) => {
          if (response.is_ok == true) {
            let _collegeId = response.college_info.college_id
            if (_collegeId && _collegeId !== 0) {
              setCollegeId(_collegeId)
              setCollegeInfo(response.college_info)
              setCollegeName(response.college_info.college_name)
            }
            setIsTeacher(response.college_info?.is_college_teacher)
          }
        }
      )
    }
    sendHttpPostRequest('course/api/get_online_logo_info', {}, (res) => {
      if (res.code == 0) {
        setLogoInfo(res.data)
      } else {
        message.error(res.msg)
      }
    })
  }, [])

  return (
    <div className={headerStyle.Header}>
      <Row justify="center" align="middle" className={headerStyle.headerRow}>
        <Col flex={'150px'} className={headerStyle.logoCol}>
          {collegeInfo && collegeInfo?.logo_url !== '' ? 
        
              <img
                onClick={handleMainPage}
                height="40px"
                src={constants.BACKEND_API_URL + collegeInfo?.logo_url}
                className={headerStyle.logo}
              /> :

              <img
                onClick={handleMainPage}
                key={'index_page'}
                id={'menu-0'}
                title="数据实验楼"
                alt="logo"
                src={constants.BACKEND_API_URL + logoInfo?.image_path}
                height="32px"
                className={headerStyle.logo}
              ></img>

        
           }
        </Col>

        <Col flex="auto" className={headerStyle.navCol}>
          <Menu
            theme="light"
            mode="horizontal"
            selectedKeys={[selectedKey]}
            onClick={handleClick}
            className={headerStyle.navMenu}
          >
            <Menu.Item key={'projects'} >
              实训项目
            </Menu.Item>
            <Menu.Item key={'key_features'} >
              产品理念
            </Menu.Item>
            <Menu.Item key={'colleges'} >
              入驻高校
            </Menu.Item>
          </Menu>
        </Col>
        <Col className={headerStyle.actionCol}>
          <LoginRegisterModal></LoginRegisterModal>
          <UserInfo></UserInfo>
        </Col>
      </Row>
    </div>
  )
}

export default PageHeader
